import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

/**
 * GoogleAnalytics component for tracking SPA route changes
 * This component automatically tracks page views when routes change
 */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Track pageview on route change
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location]);

  return null; // This component doesn't render anything
}

